export function SectionLabel({ children }: { children: string }) {
  return (
    <p style={{
      fontSize: 'var(--text-xs)',
      fontWeight: 600,
      letterSpacing: '0.5px',
      color: 'var(--muted-foreground)',
      marginBottom: '6px',
    }}>
      {children}
    </p>
  );
}

export function SectionTitle({ children, size = 'lg' }: { children: string; size?: 'lg' | 'xl' }) {
  return (
    <p style={{
      fontSize: size === 'xl' ? 'var(--text-2xl)' : 'var(--text-lg)',
      fontWeight: 600,
      color: 'var(--foreground)',
      marginBottom: '6px',
    }}>
      {children}
    </p>
  );
}

export function DSLoadingRow() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 0' }}>
      <div style={{ height: '12px', borderRadius: '4px', backgroundColor: 'var(--muted)', flex: 1, opacity: 0.5 }} />
    </div>
  );
}

export function DSEmptyState({ message }: { message: string }) {
  return (
    <div style={{
      padding: '48px 64px',
      textAlign: 'center',
      color: 'var(--muted-foreground)',
      fontSize: 'var(--text-sm)',
    }}>
      {message}
    </div>
  );
}
